<template lang="pug">
  div
    b-row
      .col-xl-3.col-md-6
        .widget.widget-stats.bg-blue
          .stats-icon
            i.fa.fa-chart-line
          .stats-info
            h4 {{ $t("ui.winlose_today") }}
            p {{ todayWinlose | currency }}
      .col-xl-3.col-md-6
        .widget.widget-stats.bg-info
          .stats-icon
            i.fa.fa-chart-line
          .stats-info
            h4 {{ $t("ui.winlose_yesterday") }}
            p {{ yesterdayWinlose | currency }}
      .col-xl-3.col-md-6
        .widget.widget-stats.bg-warning
          .stats-icon
            i.fa.fa-balance-scale
          .stats-info
            h4 {{ $t("ui.total_outstanding") }}
            p {{ totalOutstanding | currency }}
      .col-xl-3.col-md-6
        .widget.widget-stats.bg-danger
          .stats-icon
            i.fa.fa-users
          .stats-info
            h4 {{ $t("ui.online_player") }}
            p {{ onlinePlayer }}
      .col-xl-3
        panel(:title='$t("ui.balance")')
          .row.flex
            .col-sm-12.col-md-12.col-lg-12.col-xl-12
              .table-responsive
                table.table.table-sm.table-bordered
                  tbody
                    tr
                      th.width-xs(scope='row') {{ $t("ui.cash_balance")}}
                      td
                        currency(:currency="$store.getters.getAccountCurrency")
                        span(:class="$helpers.getNumberClass($store.getters.getAccountCashBalance)") {{ Math.floor($store.getters.getAccountCashBalance * 100) / 100 | currency }}
                    template(v-if="!['MMK','MMO'].includes($store.getters.getAccountCurrency)")
                      tr
                        th(scope='row') {{ $t("ui.account_balance")}}
                        td
                          currency(:currency="$store.getters.getAccountCurrency")
                          span(:class="$helpers.getNumberClass($store.getters.getAccountBalance)") {{ $store.getters.getAccountBalance | currency }}
                      tr
                        th(scope='row') {{ $t("ui.member_balance")}}
                        td
                          currency(:currency="$store.getters.getAccountCurrency")
                          span(:class="$helpers.getNumberClass($store.getters.getAccountBalance -$store.getters.getAccountCashBalance)") {{ $store.getters.getAccountBalance -$store.getters.getAccountCashBalance | currency }}
                      tr
                        th.width-150(scope='row') {{ $t("ui.credit_limit") }}
                        td
                          currency(:currency="$store.getters.getAccountCurrency")
                          span(:class="$helpers.getNumberClass($store.getters.getAccountCreditLimit)") {{ $store.getters.getAccountCreditLimit | currency }}
                      tr
                        th(scope='row') {{ $t("ui.remaining_credit") }}
                        td
                          currency(:currency="$store.getters.getAccountCurrency")
                          span(:class="$helpers.getNumberClass($store.getters.getAccountCreditLimit - $store.getters.getCreditUsedDownline)") {{ $store.getters.getAccountCreditLimit - $store.getters.getCreditUsedDownline | currency }}
                      tr
                        th(scope='row') {{ $t("ui.total") + " " + $t("ui.downline_credit") }}
                        td
                          currency(:currency="$store.getters.getAccountCurrency")
                          span(:class="$helpers.getNumberClass($store.getters.getCreditUsedDownline)") {{ $store.getters.getCreditUsedDownline | currency }}
            .col-sm-12.col-md-12.col-lg-12.col-xl-12
              .table-responsive
                table.table.table-sm.table-bordered
                  tbody
                    template(v-for="n in creditUsedSummary")
                      tr
                        th.width-xs(scope='row') {{ $helpers.getUplineName(n.account_type) + ' ' + $t("ui.credit") }}
                        td
                          currency(:currency="$store.getters.getAccountCurrency")
                          span(:class="$helpers.getNumberClass(n.given_credit)") {{ n.given_credit | currency }}
        
        panel(:title='$t("ui.account_status")')
          .row.flex
            .col-sm-12.col-md-12.col-lg-12.col-xl-12
              .table-responsive
                table.table.table-sm.table-bordered
                  tbody
                    tr
                      th.w-auto.text-center.bg-grey
                      th.w-auto.text-center.bg-grey(style="width:20%;") {{ $t("ui.active") }}
                      th.w-auto.text-center.bg-grey(style="width:20%;") {{ $t("ui.close") }}
                      //- td.w-auto.text-center {{ $t("ui.freeze") }}
                      th.w-auto.text-center.bg-grey(style="width:20%;") {{ $t("ui.suspend") }}
                    template(v-for="n in Object.keys(agentList).reverse()")
                      tr
                        th(scope='row') {{ $helpers.getUplineName(parseInt(n)) }}
                        td.text-center
                          span.badge.badge-success {{ (agentList[n]["ACTIVE"] > 0) ? agentList[n]["ACTIVE"] : 0 }}
                        td.text-center
                          span.badge.badge-danger {{ (agentList[n]["CLOSE"] > 0) ? agentList[n]["CLOSE"] : 0 }}
                        //- td.text-center
                        //-   span.badge.badge-blue {{ totalFreeze }}
                        td.text-center
                          span.badge.badge-black {{ (agentList[n]["SUSPEND"] > 0) ? agentList[n]["SUSPEND"] : 0 }}
                    template(v-for="(n,i) in memberList")
                      tr
                        th(scope='row') {{ $helpers.getUplineName(parseInt(1)) }}
                        td.text-center
                          span.badge.badge-success {{ n.active || n.active_downline || 0 }}
                        td.text-center
                          span.badge.badge-danger {{ n.close || n.close_downline || 0 }}
                        //- td.text-center
                        //-   span.badge.badge-blue {{ totalFreeze }}
                        td.text-center
                          span.badge.badge-black {{ n.suspend || n.suspend_downline || 0 }}
      .col-xl-3
        panel(:title='$t("ui.top_winner")')
          .row.flex
            .col-sm-12.col-md-12.col-lg-12.col-xl-12
              .table-responsive
                table.table.table-sm.table-bordered
                  thead
                    th.w-auto.text-center.bg-grey #
                    th.w-auto.text-center.bg-grey {{ $t("ui.member")}}
                    th.w-auto.text-center.bg-grey {{ $t("ui.amount")}}
                  tbody
                    tr(v-for="(member,index) in topWinner" :keys="index")
                      td.w-auto.text-center {{ index+1 }}
                      td.w-auto.text-center {{ member.account_id }}
                      td.w-auto.text-center
                        span(:class="$helpers.getNumberClass(member.winlose)") {{ member.winlose | currency }}
      .col-xl-3
        panel(:title='$t("ui.top_loser")')
          .row.flex
            .col-sm-12.col-md-12.col-lg-12.col-xl-12
              .table-responsive
                table.table.table-sm.table-bordered
                  thead
                    th.w-auto.text-center.bg-grey #
                    th.w-auto.text-center.bg-grey {{ $t("ui.member")}}
                    th.w-auto.text-center.bg-grey {{ $t("ui.amount")}}
                  tbody
                    tr(v-for="(member,index) in topLoser" :keys="index")
                      td.w-auto.text-center {{ index+1 }}
                      td.w-auto.text-center {{ member.account_id }}
                      td.w-auto.text-center
                        span(:class="$helpers.getNumberClass(member.winlose)") {{ member.winlose | currency }}
      .col-xl-3
        panel(:title='$t("ui.top_turnover")')
          .row.flex
            .col-sm-12.col-md-12.col-lg-12.col-xl-12
              .table-responsive
                table.table.table-sm.table-bordered
                  thead
                    th.w-auto.text-center.bg-grey #
                    th.w-auto.text-center.bg-grey {{ $t("ui.member")}}
                    th.w-auto.text-center.bg-grey {{ $t("ui.turnover")}}
                  tbody
                    tr(v-for="(member,index) in topTurnover" :keys="index")
                      td.w-auto.text-center {{ index+1 }}
                      td.w-auto.text-center {{ member.account_id }}
                      td.w-auto.text-center
                        span(:class="$helpers.getNumberClass(member.turnover)") {{ member.turnover | currency }}

</template>

<script>
import currency from "@/components/settings/currency.vue"

export default {
  components: {
    currency
  },
  data() {
    return {
      totalActive: 0,
      totalClose: 0,
      totalFreeze: 0,
      totalSuspend: 0,
      todayWinlose: 0,
      yesterdayWinlose: 0,
      totalOutstanding: 0,
      onlinePlayer: 0,
      topWinner: [],
      topTurnover: [],
      topLoser: [],
      creditUsedSummary: [],
      agentList: {},
      memberList: [],
      pulling: null
    }
  },
  computed: {},
  created: function() {
    this.pulling = setInterval(() => this.startOverview(), 1 * 300000);
  },
  beforeDestroy() {
    clearInterval(this.pulling);
  },
  mounted: function(){
    const runAccountActionLogCheck = () => {
      //here need to check if the account action log row count is greater than 0
      //if greater than 0, then show the alert else hide the alert
      //account action log for previous 7 days from today
      let start_date = this.$moment().subtract(7, 'days').format('YYYY-MM-DD');
      let end_date = this.$moment().format('YYYY-MM-DD');
      let search_id = "";
      let page_number = 1;
      let page_size = 10;
      let sort_key = "action_date";
      let sort_type = "DESC";

      this.$store.dispatch("layout/setDateRange", {
        startDate: start_date,
        endDate: end_date
      });

      const resetDateRangeToToday = () => {
        const today = this.$moment().subtract(12, 'hours').format("YYYY-MM-DD");
        this.$store.dispatch("layout/setDateRange", {
          startDate: today,
          endDate: today
        });
      };

      this.$store.dispatch("log/getAccountActionLog", { search_id, start_date, end_date, page_number, page_size, sort_key, sort_type }).then(response => {
        const hasRows = response.success === true && response.data && response.data.length > 0;
        if (hasRows) {
          this.$swal({
            title: this.$t("ui.account_action_log"),
            text: this.$t("message.account_action_log_alert"),
            type: "warning",
            allowOutsideClick: false
          }).then(() => {
            this.$router.push("/accountActionLog");
            localStorage.setItem("account_action_log_alert", "true");
          });
        } else {
          resetDateRangeToToday();
        }
      }).catch(() => {
        resetDateRangeToToday();
      });
    };

    if (!localStorage.getItem("popupClosed")) {
      // console.log(this.$store.getters.authorityRole)
      this.$swal({
        html: this.$t("message.notice"),
        allowOutsideClick: false
      }).then(() => {
        localStorage.setItem("popupClosed", "true");
        if(this.$store.getters.authorityRole != "SUB_PRI") {
          runAccountActionLogCheck();
        }
      });
    }

    //check last password changed more than 90days
    // console.log(this.$store.getters.lastPasswordChanged);
    let lastPasswordChanged = this.$store.getters.lastPasswordChanged;
    const expiryDate = this.$moment(lastPasswordChanged).add(9000, 'days');
    const currentDate = this.$moment();

    if (expiryDate.isBefore(currentDate)) {
      // Password has expired
      // Block and raise a message
      this.$swal({
        title: this.$t("ui.password_expired"),
        text: this.$t("message.password_expired_alert"),
        type: "warning",
        allowOutsideClick: false
      }).then(() => {
        this.$router.push("/resetPassword")
      });
    } else {
      // Password is still valid
      this.startOverview()
      var swal_alert = localStorage.getItem("alert");
      if(swal_alert != 1){
        let status = this.$store.getters.accountStatus
        if(status == 'SUSPEND') {
          this.$swal({
            title: this.$t("ui.suspend"),
            text: this.$t("message.suspend_alert"),
            html: "<div>" + this.$t("message.suspend_alert1") + "</div>" +
                  "<div>" + this.$t("message.suspend_alert2") + "</div>",
            type: "warning",
            allowOutsideClick: false
          })
        }
      }
      localStorage.setItem("alert", "1");
    }
  },
  methods: {
    startOverview: function() {
      this.$helpers.getCreditLimit(this.$store.getters.accountID, this.$store.getters.accountType)
      this.$helpers.getPositionTaking()
      this.$helpers.getCommission()
      this.$helpers.getBetLimit()
      this.$helpers.getSchedule()
      this.$helpers.getWallet()
      this.$helpers.getPlatform()
      this.getOverviewSummary()
      this.getAccountWinlose()
      this.getAccountOutstanding()
      this.getTop10Account()
      this.getActiveAccount()
      this.getCreditUsedSummary()
      if(this.$store.getters.accountType == 2) {
        if(['MYR', 'THB', 'SGD', 'USD', 'CNY'].includes(this.$store.getters.getAccountCurrency)) {
          this.getMemberListAlert()
        }
      }
    },
    getOverviewSummary: function(){
      this.$store
        .dispatch("user/getOverviewSummary")
        .then(response => {
          if (response.success == true) {
            if(response.data.agent) {
              let agent = {}
              response.data.agent.forEach(x => {
                if(!agent.hasOwnProperty(x.account_type)) {
                  agent[x.account_type] = {}
                }
                if(!agent[x.account_type].hasOwnProperty(x.status)) {
                  agent[x.account_type][x.status] = x.cnt
                }
              });
              this.agentList = agent
            }

            if(response.data.member) {
              this.memberList = response.data.member
            }
          }
        })
        .catch(response => {
        });
    },
    getAccountWinlose: function(){
      this.$store
        .dispatch("user/getAccountWinlose")
        .then(response => {
          if (response.success == true) {
            this.todayWinlose = response.data.details[0].today_winlose
            this.yesterdayWinlose = response.data.details[0].yesterday_winlose
          }
        })
        .catch(response => {
        });
    },
    getAccountOutstanding: function(){
      this.$store
        .dispatch("user/getAccountOutstanding")
        .then(response => {
          if (response.success == true) {
            this.totalOutstanding = response.data.details[0].total_outstanding | 0
          }
        })
        .catch(response => {
        });
    },
    getActiveAccount: function(){
      this.$store
        .dispatch("user/getActiveAccount")
        .then(response => {
          if (response.success == true) {
            this.onlinePlayer = response.data.details[0].active_member_count | 0
          }
        })
        .catch(response => {
        });
    },
    getTop10Account: function(){
      this.$store
        .dispatch("user/getTop10Account")
        .then(response => {
          if (response.success == true) {
            this.topWinner = response.topwinner
            this.topTurnover = response.turnover
            this.topLoser = response.toploser
          }
        })
        .catch(response => {
        });
    },
    getCreditUsedSummary: function(){
      this.$store
        .dispatch("user/getCreditUsedSummary")
        .then(response => {
          if (response.success == true) {
            this.creditUsedSummary = response.data.reverse()
          }
        })
        .catch(response => {
        });
    },
    getMemberListAlert: function() {
      let page_number = 1
      this.currentPage = parseInt(page_number)
      let page_size = 10
      let sort_key = "account_id"
      let sort_type = "DESC"
      this.$store
        .dispatch("user/getMemberListAlert", { page_number, page_size, sort_key, sort_type })
        .then(response => {
          if (response.success == true) {
            if(response.data.length > 0) {
              this.$store.dispatch("user/setPlayerAlert", true)
              // console.log(this.$store.getters.getPlayerAlertCall)
              if(this.$store.getters.getPlayerAlertCall == 0) {
                this.$store.dispatch("user/setPlayerAlertCall", 1)
                this.$swal({
                  title: this.$t("ui.account_list_alert"),
                  // text: this.$t("ui.player_alert"),
                  type: "warning",
                  showCancelButton: true,
                  allowOutsideClick: false
                }).then(result => {
                  if (result.value) {
                    this.$router.push("/accountListAlert")
                  }
                });
              }
            } else {
              this.$store.dispatch("user/setPlayerAlert", false)
            }
          }
        })
        .catch(response => {
        });
    }
  }
}
</script>